<template>
  <div class="flex flex-col md:items-center">
    <MarkupGenerator
      v-if="configData?.innerMarkup"
      :page-data="{ PageContent: [...configData.innerMarkup] as any }"
      :is-page="false"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    innerMarkup?: any;
  };
}

defineProps<Props>();
</script>

<style></style>
